<template>
  <button :class="`sb_button sb_button-${type}`">
    <span class="sb_button_icon-left" v-if="$slots['icon-left']">
      <slot name="icon-left" />
    </span>
    <span class="sb_button_wrapper">
      <slot name="content" v-if="$slots.content" />
      <slot v-else />
    </span>
    <span class="sb_button_icon-right" v-if="$slots['icon-right']">
      <slot name="icon-right" />
    </span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'normal',
    },
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_button {
    border-radius: $default-radius;
    display: flex;
    font-weight: 700;
    font-size: 0.9rem;
    padding: 0.8rem 1rem;
    letter-spacing: 1px;
    align-items: center;
    justify-content: center;
    transition: background 0.4s, color 0.4s;
    height: 100%;
    &:hover {
      cursor: pointer;
    }
    &_icon-right,
    &_icon-left {
      font-size: 80%;
      @include media('>=small') {
        font-size: 95%;
      }
      @include media('>=medium') {
        font-size: 105%;
      }
    }
    &_icon-right {
      margin-left: 0.4rem;
      @include media('>=medium') {
        margin-left: 0.6rem;
      }
    }
    &_icon-left {
      margin-right: 0.4rem;
      @include media('>=medium') {
        margin-right: 0.6rem;
      }
    }
    &_wrapper {
      display: flex;
      @include media('>=small') {
        transform: translateY(1px);
      }
    }
    &-ghost {
      border: 3px solid $brand-black;
      color: $brand-primary;
      &:hover {
        color: $brand-primary-light;
      }
    }
    &-cancel {
      font-weight: 700;
      padding-left: 0.4rem;
      padding-right: 0;
      color: $brand-gray;
      &:hover {
        color: $brand-light-gray;
      }
    }
    &-normal {
      font-weight: 700;
      background: $brand-primary;
      color: $brand-white;
      &:hover {
        background: $brand-primary-light;
      }
    }
    @include media('>=medium') {
      font-size: 1rem;
    }
  }
}
</style>
